/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tab, Tabs, useMediaQuery } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../../Styles/dashboard.module.css";
import { localUrlEnum } from "../../Utils/UrlEnum";
import { costsTypes } from "../../Utils/AutocompleteUtils";
import theme from "../../Themes/Theme";
import ManualCosts from "./ManualCosts";
import AutomaticCosts from "./AutomaticCosts";

export default function CostsMainPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [value, setValue] = useState(0);

  useEffect(() => {
    const search: any = location.search.split("?");
    search.forEach((value: any) => {
      if (value !== "") {
        const params = value.split("&");
        const values = params[0].split("=");
        setValueFromLocation(values[1]);
      }
    });
  }, [location]);

  /**
   *
   * @param newValue
   */
  function setValueFromLocation(newValue: string) {
    switch (newValue) {
      case costsTypes.manual:
        setValue(0);
        break;
      case costsTypes.automatic:
        setValue(1);
        break;
      default:
        setValue(0);
        break;
    }
  }
  /**
   *
   * @param event
   * @param newValue
   */
  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    switch (newValue) {
      case 0:
        navigate(`${localUrlEnum.costs}?type=${costsTypes.manual}`);
        break;
      case 1:
        navigate(`${localUrlEnum.costs}?type=${costsTypes.automatic}`);
        break;
      default:
        navigate(`${localUrlEnum.costs}?type=${costsTypes.manual}`);
        break;
    }
  }

  /**
   *
   */
  function showInformationForTabs() {
    switch (value) {
      case 0:
        return <ManualCosts/>;
      case 1:
        return <AutomaticCosts/>;
      default:
        return <ManualCosts/>;
    }
  }

  /**
   *
   * @param tabValue
   * @returns
   */
  function getTabStyle(tabValue: number) {
    return {
      backgroundColor:
        value === tabValue
          ? theme.palette.secondary.main
          : theme.palette.cancel?.main,
      color: value === tabValue ? "white" : "#9c9b9b",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      marginRight: "1px",
    };
  }

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <Tabs
        value={value}
        onChange={handleChangeValue}
        TabIndicatorProps={{
          style: {
            backgroundColor: theme.palette.secondary.main,
          },
        }}
      >
        <Tab label={Vocabulary.manual} style={getTabStyle(0)} />
        <Tab label={Vocabulary.automatic} style={getTabStyle(1)} />
      </Tabs>
      <> {showInformationForTabs()}</>
    </div>
  );
}
